import _ from 'lodash'

const removeEmptyKeys = (obj) =>
    _.omitBy(obj, (v) => _.isUndefined(v) || _.isNull(v) || v === '')

export default removeEmptyKeys
